import { render } from "./ViewBankstatements.vue?vue&type=template&id=0b2304e1"
import script from "./ViewBankstatements.vue?vue&type=script&lang=js"
export * from "./ViewBankstatements.vue?vue&type=script&lang=js"

import "./ViewBankstatements.vue?vue&type=style&index=0&id=0b2304e1&lang=css"
script.render = render

export default script